import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {AuthGuard} from 'src/app/core/auth/auth.guard';
import {KycEnterpriseComponent} from './kyc-enterprise.component';
import {KycConfirmAccountComponent} from './kyc-confirm-account/kyc-confirm-account.component';
import {KycSignComponent} from './kyc-sign/kyc-sign.component';
import {KycCameraComponent} from './kyc-camera/kyc-camera.component';
import { KycCustomerIdentifyComponent } from './kyc-customer-identify/kyc-customer-identify.component';
import { IdentificationMethodComponent } from './identification-method/identification-method.component';
import { KycConfirmAccountReviewComponent } from './kyc-confirm-account-review/kyc-confirm-account.component';

const routes: Routes = [
  {
    path: 'kyc-enterprise',
    component: KycEnterpriseComponent,
    // canActivate: [AuthGuard],
    loadChildren: () => import('../kyc/kyc-enterprise.module').then(m => m.KycEnterpriseModule)
  },
  {
    path: 'identification-method/:hashKey/:tenantId',
    component: IdentificationMethodComponent,
    // canActivate: [AuthGuard],
    loadChildren: () => import('../kyc/identification-method/identification-method.module').then(m => m.IdentificationMethodModule)
  },
  {
    path: 'identification-method/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode',
    component: IdentificationMethodComponent,
    // canActivate: [AuthGuard],
    loadChildren: () => import('../kyc/identification-method/identification-method.module').then(m => m.IdentificationMethodModule)
  },
  {
    path: 'kyc-confirm-account',
    component: KycConfirmAccountComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('../kyc/kyc-confirm-account/kyc-confirm-account.module').then(m => m.KycConfirmAccountModule)
  },
  {
    path: 'kyc-customer-identify/:hashKey/:tenantId',
    component: KycCustomerIdentifyComponent,
    loadChildren: () => import('../kyc/kyc-customer-identify/kyc-customer-identify.module').then(m => m.KycCustomerIdentifyModule)
  },{
    path: 'kyc-customer-identify/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode',
    component: KycCustomerIdentifyComponent,
    loadChildren: () => import('../kyc/kyc-customer-identify/kyc-customer-identify.module').then(m => m.KycCustomerIdentifyModule)
  },
  {
    path: 'kyc-confirm-account-anonymous/:hashKey/:tenantId',
    component: KycConfirmAccountComponent,
    loadChildren: () => import('../kyc/kyc-confirm-account/kyc-confirm-account.module').then(m => m.KycConfirmAccountModule)
  },
  {
    path: 'kyc-confirm-account-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode',
    component: KycConfirmAccountComponent,
    loadChildren: () => import('../kyc/kyc-confirm-account/kyc-confirm-account.module').then(m => m.KycConfirmAccountModule)
  },
  {
    path: 'kyc-confirm-account-review',
    component: KycConfirmAccountReviewComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('../kyc/kyc-confirm-account-review/kyc-confirm-account.module').then(m => m.KycConfirmAccountModuleReview)
  },
  {
    path: 'kyc-confirm-account-review-anonymous/:hashKey/:tenantId',
    component: KycConfirmAccountReviewComponent,
    loadChildren: () => import('../kyc/kyc-confirm-account-review/kyc-confirm-account.module').then(m => m.KycConfirmAccountModuleReview)
  },
  {
    path: 'kyc-confirm-account-review-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode',
    component: KycConfirmAccountReviewComponent,
    loadChildren: () => import('../kyc/kyc-confirm-account-review/kyc-confirm-account.module').then(m => m.KycConfirmAccountModuleReview)
  },
  {
    path: 'kyc-sign',
    component: KycSignComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('../kyc/kyc-sign/kyc-sign.module').then(m => m.KycSignModule)
  },
  {
    path: 'kyc-sign-anonymous/:hashKey/:tenantId',
    component: KycSignComponent,
    loadChildren: () => import('../kyc/kyc-sign/kyc-sign.module').then(m => m.KycSignModule)
  },
  {
    path: 'kyc-sign-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode',
    component: KycSignComponent,
    loadChildren: () => import('../kyc/kyc-sign/kyc-sign.module').then(m => m.KycSignModule)
  },
  {
    path: 'kyc-camera',
    component: KycCameraComponent,
    canActivate: [AuthGuard],
    loadChildren: () => import('../kyc/kyc-camera/kyc-camera.module').then(m => m.KycCameraModule)
  },
  {
    path: 'kyc-camera-anonymous/:hashKey/:tenantId',
    component: KycCameraComponent,
    loadChildren: () => import('../kyc/kyc-camera/kyc-camera.module').then(m => m.KycCameraModule)
  }
  ,
  {
    path: 'kyc-camera-anonymous/:hashKey/:tenantId/:contractIdAndContractEnterpriseIdEncode',
    component: KycCameraComponent,
    loadChildren: () => import('../kyc/kyc-camera/kyc-camera.module').then(m => m.KycCameraModule)
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes), TranslateModule],
  exports: [RouterModule],
})
export class KycEnterpriseRoutingModule { }
